import React from 'react';
import { Button, Tooltip } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import HelpTooltipIcon, { HelpIcon } from '../../../../shared/components/HelpTooltipIcon';

const ContentsLibraryPanelHeader = ({  }) => {
  const { t } = useTranslation();

  const handleOpenTutorial = () => {
    window.open('https://www.youtube.com/watch?v=ABgBDytnAAk', '_blank');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{t('Contents library')}</span>
      <Tooltip title={
          <Trans
            i18nKey="I don’t have my ads tooltip"
            components={{ icon: <HelpIcon secondary={true} /> }}
          />
      }>
        <Button
          type="primary"
          size="small"
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          onClick={handleOpenTutorial}
        >
          {t('I don’t have my ads')}
          <HelpIcon secondary={true} />
        </Button>
      </Tooltip>
    </div>
  );
};

export default ContentsLibraryPanelHeader;
